import StagePanel from "../../../lib/stage_panel";

// Shared base for the five MemberOfferAcceptor form panels (AcceptForm, AccountForm,
// VerifyForm, PasswordForm, ForgotForm) — and for the smaller pieces a panel composes
// (AcceptSubmitButton), which want exactly the same plumbing. Named for the family's
// primary member so it no longer reads like the host class, matching the vocabulary
// moa_panel_hints.js already owns.
//
// The state-machine wiring + the renderPanelVisibility preamble now live in the shared
// lib/stage_panel base (extracted once three families had grown identical copies). MoaPanel
// keeps its name and import path so the MOA panels are untouched; the family-specific bits
// worth sharing beyond the base plumbing (the markup vocabulary, the auth-status hint
// painting) stay plain values/functions in moa_panel_hints.js, imported where wanted.
export default class MoaPanel extends StagePanel {}
